var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */
import { Injectable } from '@angular/core';
import { CommonUserContextService, ConfigurationHttpRequestInterceptor } from '@gh/common-shared';
import { REGION_CODE } from '@gh/config';
import { AuthService } from '@gh/core-auth';
import { isNotNil } from '@gh/core-util';
import { mapTo$, switchMap$, tap$ } from '@gh/rx/operators';
import { SupplierOfficeRestService, SupplierUserProfileRestService } from '@gh/supplier-shared-data';
import { find, isNil } from 'lodash';
import { SupplierUserProfileStore } from './supplier-user-profile-store.service';
import * as i0 from "@angular/core";
import * as i1 from "@gh/core-auth";
import * as i2 from "@gh/supplier-shared-data";
import * as i3 from "./supplier-user-profile-store.service";
import * as i4 from "@gh/common-shared";
var SupplierUserContextService = /** @class */ (function (_super) {
    __extends(SupplierUserContextService, _super);
    function SupplierUserContextService(authService, profileRest, officeRest, store, configurationHttpRequestInterceptor) {
        var _this = _super.call(this, authService, store) || this;
        _this.profileRest = profileRest;
        _this.officeRest = officeRest;
        _this.store = store;
        _this.configurationHttpRequestInterceptor = configurationHttpRequestInterceptor;
        _this._offices = [];
        return _this;
    }
    Object.defineProperty(SupplierUserContextService.prototype, "offices", {
        get: function () {
            this.checkUserInitialized();
            return this._offices;
        },
        set: function (offices) {
            throw new Error('SupplierUserContextService: list of offices cannot be changed');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SupplierUserContextService.prototype, "currentOffice", {
        get: function () {
            this.checkUserInitialized();
            return this._currentOffice;
        },
        set: function (office) {
            throw new Error("SupplierUserContextService: to change office use setCurrentOffice method");
        },
        enumerable: true,
        configurable: true
    });
    SupplierUserContextService.prototype.init = function (params) {
        var _this = this;
        var acceptedOfficeId = params.acceptedOfficeId;
        return _super.prototype.init.call(this, params).pipe(switchMap$(function (userData) { return acceptedOfficeId
            ? _this.profileRest.acceptInvitation(acceptedOfficeId).pipe(mapTo$(userData))
            : [userData]; }), switchMap$(function (userData) {
            return _this.officeRest.findAll().pipe(tap$(function (offices) {
                _this._offices = offices;
                if (offices.length) {
                    _this.setCurrentOffice(offices[0].id);
                }
            }), mapTo$(userData));
        }));
    };
    SupplierUserContextService.prototype.setCurrentOffice = function (id) {
        if (this._currentOffice && this._currentOffice.id === id) {
            return;
        }
        var nextOffice = find(this._offices, { id: id });
        if (isNil(nextOffice)) {
            throw new Error("SupplierUserContextService: id \"" + id + "\" does not correspond to any of loaded offices");
        }
        this._currentOffice = nextOffice;
        this.configurationHttpRequestInterceptor.setHeader('X-OfficeId', nextOffice.id);
    };
    SupplierUserContextService.prototype.isOfficeExist = function (id) {
        return isNotNil(this.getOffice(id));
    };
    SupplierUserContextService.prototype.getOffice = function (id) {
        return find(this._offices, { id: id });
    };
    SupplierUserContextService.prototype.updateReceiveEmails = function (receiveEmails) {
        this.store.updateReceiveEmails(receiveEmails);
    };
    SupplierUserContextService.prototype.hasPermission = function (permission) {
        throw new Error('SupplierUserContext: permissions are not supported');
    };
    SupplierUserContextService.prototype.updateUserData = function (user) {
        // nothing to do
    };
    SupplierUserContextService.prototype.setupHttpHeaders = function (params) {
        this.configurationHttpRequestInterceptor.headers = {
            'X-Region': REGION_CODE,
        };
    };
    SupplierUserContextService.ɵfac = function SupplierUserContextService_Factory(t) { return new (t || SupplierUserContextService)(i0.ɵɵinject(i1.AuthService), i0.ɵɵinject(i2.SupplierUserProfileRestService), i0.ɵɵinject(i2.SupplierOfficeRestService), i0.ɵɵinject(i3.SupplierUserProfileStore), i0.ɵɵinject(i4.ConfigurationHttpRequestInterceptor)); };
    SupplierUserContextService.ɵprov = i0.ɵɵdefineInjectable({ token: SupplierUserContextService, factory: SupplierUserContextService.ɵfac });
    return SupplierUserContextService;
}(CommonUserContextService));
export { SupplierUserContextService };
/*@__PURE__*/ (function () { i0.ɵsetClassMetadata(SupplierUserContextService, [{
        type: Injectable
    }], function () { return [{ type: i1.AuthService }, { type: i2.SupplierUserProfileRestService }, { type: i2.SupplierOfficeRestService }, { type: i3.SupplierUserProfileStore }, { type: i4.ConfigurationHttpRequestInterceptor }]; }, null); })();
